export { default as UserCircleIcon } from './UserCircleIcon';
